import * as React from 'react'
import HTMLRenderer from 'react-html-renderer'
import BodyText from './Typography/BodyText'
import List from 'components/Common/List'
import { rem } from 'polished'
import styled from 'styled-components'

const SpacedList = styled(List)`
  margin-block: ${rem(16)};
`

const HTMLPText = styled(BodyText)`
  & + * {
    margin-top: ${rem(16)};
  }
`

interface Props {
  content: string
}

const components: React.ComponentProps<typeof HTMLRenderer>['components'] = {
  p: (props) => <HTMLPText {...props} variant="medium" colour="neutral-two" />,
  ul: (props) => <SpacedList {...props} />,
  li: (props) => <BodyText {...props} variant="medium" as="li" />,
}

function HTMLRender(props: Props) {
  const { content } = props
  return <HTMLRenderer
    html={content}
    components={components}
  />
}

export default React.memo(HTMLRender)
